export enum TwoFactorMessages {
  InvokeDropAccountButtonClick = 'InvokeDropAccountButtonClick',
  InvokeSavePasswordButtonClick = 'InvokeSavePasswordButtonClick',
  InvokeDropUserButtonClick = 'InvokeDropUserButtonClick',
  TurnTwoFactorAuthCheckBox = 'TurnTwoFactorAuthCheckBox',
  InvokeResetAlternativeCodesClick = 'InvokeResetAlternativeCodesClick',
  TwoFactorAuthCheckBoxOnClickInvoke = 'TwoFactorAuthCheckBoxOnClickInvoke'
}

export type TFAData = {
  authId: string;
  type: number;
  actionType: TwoFactorAuthActionType;
  timeExpired: string;
};

export enum TwoFactorAuthActionType {
  None = 0,
  EmergencyLogin = 1,
  Login = 2,
  DropCloudAccount = 3,
  DropUser = 4,
  RmmAction = 5,
  ResetAlternativeCodes = 6,
  TurnOffTwoFactorAuth = 7,
  TurnOnTwoFactorAuth = 8,
  ChangePassword = 9,
  PasswordRecovery = 10,
  ChangeEmail = 11,
  DeleteCapacityReportUser = 12,
  DeleteCapacityReportComputer = 13,
  DeleteDomain = 15,
  UpdateDomain = 16,
  PasswordRecoveryOnWizard = 18,
  ReserveAuthorizationMethod = 20
}

export enum TwoFactorAuthenticationType {
  None = 0,
  Google = 'TimeBasedOneTimeCode',
  MbsApp = 'MbsApp',
  Alternative = 'Alternative'
}

export const TwoFactorAuthenticationTypeMap = {
  1: 'TimeBasedOneTimeCode',
  2: 'MbsApp',
  3: 'Alternative'
};

export enum PostMessageTwoFactorAuthenticationType {
  None,
  Google,
  MbsApp,
  Alternative
}

export interface ReserveAuthSettings {
  enabled: boolean;
  phone: string;
  email: string;
  lockSeconds: number;
}

export interface AddReserveAuthResponse {
  success: boolean;
  retryAvailableDate: string;
}

export interface AddReserveAuthRequest {
  authId: string;
  value: string;
}

export interface ConfirmReserveAuthResponse {
  isValid: boolean;
}

export interface SendReserveAuthRequest {
  authId: string;
}

export interface ConfirmReserveAuthRequest {
  authId: string;
  code: string;
}

export enum ReserveAuthSteps {
  SendPhoneCode,
  ConfirmPhoneCode,
  SendEmailCode,
  ConfirmEmailCode,
  Complete
}

export type QrCode = {
  qrCodeUrl: string;
  timeExpired: string;
};
